import { render, staticRenderFns } from "./Sertificates.vue?vue&type=template&id=98a2cb44&scoped=true&"
import script from "./Sertificates.vue?vue&type=script&lang=js&"
export * from "./Sertificates.vue?vue&type=script&lang=js&"
import style0 from "./Sertificates.vue?vue&type=style&index=0&id=98a2cb44&scoped=true&lang=css&"
import style1 from "./Sertificates.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a2cb44",
  null
  
)

export default component.exports